import React from 'react';

import TwitterIcon from 'components/icons/share/Twitter'
import LinkedinIcon from 'components/icons/share/Linkedin'
import FacebookIcon from 'components/icons/share/Facebook'

const socialLink = [
  {
    icon: <TwitterIcon fill="white" width="20" height="20" />,
    href: "https://twitter.com/scale_AI"
  },
  {
    icon: <FacebookIcon fill="white" width="20" height="20" />,
    href: "https://www.facebook.com/scaleapi"
  },
  {
    icon: <LinkedinIcon fill="white" width="20" height="20" />,
    href: "https://www.linkedin.com/company/scaleai"
  }
]

const PreHero = ({ type }) => (
  <div className="hidden lg:flex py-2 mt-4 justify-between">
    <p className="uppercase text-sm tracking-[3px]">
      {type}
    </p>
    <ul className="flex space-x-7">
      {socialLink.map((l) => (
        <li>
          <a href={l.href} target="_blank" rel="noreferrer" >
            {l.icon}
          </a>
        </li>
      ))}
    </ul>
  </div>
)

export default PreHero;